import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ArticlePage from "../pages/article/page";
import AuthorPage from "../pages/author/page";
import ColumnistsPage from "../pages/columnists/page";
import SearchPage from "../pages/search/page";
import ContactPage from "../pages/contact/page";
import AboutPage from "../pages/about/page";
import ImpressumPage from "../pages/impressum/page";
import DatenschutzPage from "../pages/datenschutz/page";
import CookiePage from "../pages/cookie/page";
import MediaKitPage from "../pages/media-kit/page";
import AdminLogin from "../pages/admin/login/page";
import AdminForgotPassword from "../pages/admin/forgot-password/page";
import AdminResetPassword from "../pages/admin/reset-password/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminArticles from "../pages/admin/articles/page";
import ArticleForm from "../pages/admin/article-form/page";
import AdminBrandSettings from "../pages/admin/brand/page";
import AdminCategories from "../pages/admin/categories/page";
import AdminAuthors from "../pages/admin/authors/page";

import AdminMedia from "../pages/admin/media/page";
import AdminAds from "../pages/admin/ads/page";
import AdminHomepage from "../pages/admin/homepage/page";
import AdminBreaking from "../pages/admin/breaking/page";
import AdminSEO from "../pages/admin/seo/page";
import AdminNewsletter from "../pages/admin/newsletter/page";
import AdminPages from "../pages/admin/pages/page";
import AdminUsers from "../pages/admin/users/page";
import AdminAnalytics from "../pages/admin/analytics/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/schweiz",
    element: <CategoryPage />,
  },
  {
    path: "/finanzen",
    element: <CategoryPage />,
  },
  {
    path: "/versicherung-gesundheit",
    element: <CategoryPage />,
  },
  {
    path: "/technologie",
    element: <CategoryPage />,
  },
  {
    path: "/digital-ki",
    element: <CategoryPage />,
  },
  {
    path: "/arbeit-leben",
    element: <CategoryPage />,
  },
  {
    path: "/politik",
    element: <CategoryPage />,
  },
  {
    path: "/deals-angebote",
    element: <CategoryPage />,
  },
  {
    path: "/meinung",
    element: <CategoryPage />,
  },
  {
    path: "/kolumnen",
    element: <CategoryPage />,
  },
  {
    path: "/wirtschaft",
    element: <CategoryPage />,
  },
  {
    path: "/migration-integration",
    element: <CategoryPage />,
  },
  {
    path: "/bildung",
    element: <CategoryPage />,
  },
  {
    path: "/kategorie/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/artikel/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/autor/:slug",
    element: <AuthorPage />,
  },
  {
    path: "/kolumnisten",
    element: <ColumnistsPage />,
  },
  {
    path: "/suche",
    element: <SearchPage />,
  },
  {
    path: "/kontakt",
    element: <ContactPage />,
  },
  {
    path: "/ueber-uns",
    element: <AboutPage />,
  },
  {
    path: "/impressum",
    element: <ImpressumPage />,
  },
  {
    path: "/datenschutz",
    element: <DatenschutzPage />,
  },
  {
    path: "/cookie-richtlinie",
    element: <CookiePage />,
  },
  {
    path: "/werbung",
    element: <MediaKitPage />,
  },
  // Admin routes
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/passwort-vergessen",
    element: <AdminForgotPassword />,
  },
  {
    path: "/admin/passwort-zuruecksetzen",
    element: <AdminResetPassword />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/artikel",
    element: <AdminArticles />,
  },
  {
    path: "/admin/artikel-neu",
    element: <ArticleForm />,
  },
  {
    path: "/admin/artikel-bearbeiten/:id",
    element: <ArticleForm />,
  },
  {
    path: "/admin/kategorien",
    element: <AdminCategories />,
  },
  {
    path: "/admin/autoren",
    element: <AdminAuthors />,
  },

  {
    path: "/admin/mediathek",
    element: <AdminMedia />,
  },
  {
    path: "/admin/werbung",
    element: <AdminAds />,
  },
  {
    path: "/admin/startseite",
    element: <AdminHomepage />,
  },
  {
    path: "/admin/breaking",
    element: <AdminBreaking />,
  },
  {
    path: "/admin/seo",
    element: <AdminSEO />,
  },
  {
    path: "/admin/newsletter",
    element: <AdminNewsletter />,
  },
  {
    path: "/admin/seiten",
    element: <AdminPages />,
  },
  {
    path: "/admin/einstellungen",
    element: <AdminBrandSettings />,
  },
  {
    path: "/admin/benutzer",
    element: <AdminUsers />,
  },
  {
    path: "/admin/analytik",
    element: <AdminAnalytics />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
